<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Copyright © 2011 by Denise Grover Swank</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Cover art and design by Rebecca Curtis, CreateSpace, 2013</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">updated 2016</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Copy Editing by Carolina Valdez-Miller</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">All rights reserved.</p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">This book is a work of fiction. References to real people, events, establishments, organizations, or locations are intended only to provide a sense of authenticity, and are used fictitiously. All other characters, and all incidents and dialogue, are drawn from the author’s imagination and are not to be construed as real.</p>
<p class="subsq copyright-content">ISBN: 978-1-939996-02-2</p>
<p class="created-with-vellum"><a href="http://tryvellum.com/created" target="_blank"><span class="created-with-vellum-image-decorator"><span class="created-with-vellum-image-size-container"><img alt="Created with Vellum" class="created-with-vellum-image" src="images/vellum-created.png"/></span></span> <span class="created-with-vellum-text">Created with Vellum</span></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?c1c7b504